<template>
  <div id="Index">
    <jw-navigation>
      <banner></banner>
      <div class="page-content">
        <Form ref="formInline" :model="filter" inline>
          <FormItem prop="user">
            <Input type="text" v-model="filter.unit_name" placeholder="会员单位名称"></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="onGetMemberUnitList">搜 索</Button>
          </FormItem>
        </Form>

        <Table :columns="columns" @on-row-click="onClickMemberUnit" :data="list" no-data-text="暂无筛选结果">
          <template #logo="{ row }">
            <img :src="row.logo" style="width: 80px;height: 80px;margin: 5px;">
          </template>
        </Table>

        <div class="pagination" v-if="list.length">
          <Page
              @on-change="handlePageChangeAction"
              show-total
              :total="total"
              :page-size="page.pageSize"
          />
        </div>
      </div>
    </jw-navigation>
  </div>
</template>

<script>
import Banner from "@/views/web/home/components/Banner.vue";
import {getMemberUnitList} from "@/request/web/members";

export default {
  name: "Index",
  // 注册组件
  components: {
    Banner
  },
  // 属性
  props: {},
  // 页面数据
  data() {
    return {
      columns: [
        {
          title: '协会LOGO',
          width: 120,
          slot: 'logo'
        },
        {
          title: '会员单位名称',
          width: 228,
          key: 'unit_name'
        },
        {
          title: '负责人',
          width: 100,
          key: 'link_man'
        },
        {
          title: '联系地址',
          key: 'address'
        }
      ],
      filter: {
        unit_name: ''
      },
      total: 0,
      page: {
        pageIndex: 1,
        pageSize: 10
      },
      list: []
    }
  },
  created() {
    this.onGetMemberUnitList()
  },
  methods: {
    handlePageChangeAction(index) {
      this.page.pageIndex = index;
      this.onGetMemberUnitList();
    },
    // 获取会员单位列表
    onGetMemberUnitList() {
      getMemberUnitList({
        ...this.page,
        filter: this.filter
      }).then(res=> {
        let {total, list} = res.data.data
        this.total = total
        this.list = list
      })
    },
    onClickMemberUnit(unit) {
      this.$router.push(`/member/detail/${unit['unit_id']}`)
    }
  }
}
</script>

<style scoped>

</style>
